<div class="help-wrapper">
  @if (currentPage != null) {
    <div class="help-tabs-container">
      @for (page of currentMenu; track page; let index = $index) {
        <div class="help-tab" [class.opened]="openedTab === index">
          <div class="help-page-title ellipsis" (click)="clickTabName(index)">
            <span>{{ page.name }}</span>
          </div>
          @if (openedTab === index) {
            <div class="help-page-wrapper">
              <div class="help-page">
                <ng-template [cdkPortalOutlet]="page | helpPagePortal"></ng-template>
              </div>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="empty-placeholder" i18n>Keine Assistenzseite verfügbar</div>
  }
  <div class="spacer"></div>
</div>
